const DEFAULT_DURATION_MS = 100;

const BUTTON_SELECTOR = [
   "button",
   "[role='button']",
   "input[type='button']",
   "input[type='submit']",
   "input[type='reset']",
].join(", ");

// Android / Chrome: navigator.vibrate.
function canUseVibrate() {
   return (
      typeof navigator !== "undefined" &&
      typeof navigator.vibrate === "function"
   );
}

function isTouchableDevice() {
   if (typeof window === "undefined") return false;

   return window.matchMedia("(pointer: coarse)").matches;
}

// iOS (iPhone, iPad — și iPad-ul care se prezintă ca Mac): Safari n-are
// navigator.vibrate, dar din iOS 18 comutarea unui <input type="checkbox" switch>
// dă vibrația sistemului. Comutăm unul ascuns, la o atingere a utilizatorului.
function isIOS() {
   if (typeof navigator === "undefined") return false;
   return (
      /iP(hone|ad|od)/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
   );
}

let iosSwitch = null;

function getIOSSwitch() {
   if (iosSwitch?.isConnected) return iosSwitch;
   const label = document.createElement("label");
   label.setAttribute("aria-hidden", "true");
   label.setAttribute("data-no-haptic", "");
   label.style.display = "none";
   const input = document.createElement("input");
   input.type = "checkbox";
   input.setAttribute("switch", "");
   input.tabIndex = -1;
   label.appendChild(input);
   document.head.appendChild(label);
   iosSwitch = label;
   return label;
}

// Clicul pe comutatorul ascuns nu e al utilizatorului: îl oprim pe window, în
// faza de capturare (înaintea oricărui alt ascultător), ca meniurile care se
// închid la „clic în afară” să nu-l vadă. Comutarea (și vibrația) are loc oricum.
function isIOSSwitchEvent(event) {
   return Boolean(iosSwitch && event.target && iosSwitch.contains(event.target));
}

if (typeof window !== "undefined" && isIOS()) {
   window.addEventListener(
      "click",
      (event) => {
         if (isIOSSwitchEvent(event)) event.stopImmediatePropagation();
      },
      true,
   );
}

export function triggerHapticFeedback(durationMs = DEFAULT_DURATION_MS) {
   if (!isTouchableDevice()) return false;
   if (canUseVibrate()) {
      try {
         return navigator.vibrate(durationMs);
      } catch {
         return false;
      }
   }
   // iOS: o singură vibrație scurtă, oricare ar fi durata; merge doar în
   // răspuns la o atingere (nu la o notificare care vine singură)
   if (isIOS()) {
      try {
         getIOSSwitch().click();
         return true;
      } catch {
         return false;
      }
   }
   return false;
}

function isDisabledInteractive(el) {
   if (!el) return true;
   if (el.disabled) return true;
   if (el.getAttribute("aria-disabled") === "true") return true;
   if (el.classList?.contains("is-disabled")) return true;
   return false;
}

function resolveHapticTarget(target) {
   if (!target?.closest) return null;
   if (target.closest("[data-no-haptic]")) return null;

   const button = target.closest(BUTTON_SELECTOR);
   if (button && !isDisabledInteractive(button)) return button;

   const navLink = target.closest("a[href]");
   if (navLink && !isDisabledInteractive(navLink)) {
      const href = String(navLink.getAttribute("href") || "").trim();
      if (
         href.startsWith("/") &&
         navLink.target !== "_blank" &&
         !navLink.hasAttribute("download")
      ) {
         return navLink;
      }
   }

   return null;
}

export function bindGlobalHapticFeedback(root = document) {
   const onPress = (event) => {
      if (!resolveHapticTarget(event.target)) return;
      triggerHapticFeedback();
   };

   root.addEventListener("click", onPress, true);

   return () => {
      root.removeEventListener("click", onPress, true);
   };
}
